module.exports = __webpack_public_path__ + "img/illustration-features-tab-3.7f696303.svg";